import apartments from './apartments';
import applicantAvailability from './applicantAvailability';
import applications from './applications';
import iot from './iot';
import routes from './routes';
import showings from './showings';
import tenantProfile from './tenantProfile';
import users from './users';
export default [
    ...users,
    ...routes,
    ...apartments,
    ...applications,
    ...showings,
    ...iot,
    ...applicantAvailability,
    ...tenantProfile
];
